<template>
  <div class="nuxt-container dark-bg-2">
    <div class="container-whole">
      <div class="container-left">
        <BillArea
          ref="billarea"
          v-if="sideArea === 'POS' && !sales_return_visible"
        />
        <QutationArea v-if="sideArea === 'QUTATION' && !sales_return_visible" />
        <SalesReurnBill v-if="sales_return_visible" />
      </div>
      <div class="container-right dark-bg-2">
        <ProductList />
        <!-- <b-button v-b-toggle.brand-sidebar class="verticalButton-brand" id="popover-brand-sync" ref="brandbutton">Brands
        </b-button> -->
        <b-popover
          v-if="help_tooltip_visible"
          :show.sync="help_tooltip_visible"
          target="popover-brand-sync"
          variant="danger"
        >
          <strong>CTRL + {{ keyShortcuts.brand_view }}</strong>
        </b-popover>
      </div>
    </div>
    <BottomButtons ref="bottomButton" />
  </div>
</template>

<script>
import BillArea from "@/components/MainPage/BillArea";
import SalesReurnBill from "@/components/saleReturn/SalesReturnPage.vue";
import QutationArea from "@/components/qutation/Create";
import BottomButtons from "@/components/MainPage/BottomButtons";
import ProductList from "@/components/MainPage/ProductList";
import ShortCutKeys from "@/mixins/ShortCutKeys";
import { mapState } from "vuex";
export default {
  name: "Dashboard",
  mixins: [ShortCutKeys],
  components: {
    BillArea,
    QutationArea,
    ProductList,
    BottomButtons,
    SalesReurnBill,
  },
  data() {
    return {
      Category: "",
      showPopups: true,
      externalContent: "",
    };
  },
  created: function () {
    // this.$router.push("/login");
  },
  mounted() {
    this._keyListener = function (e) {
      // open Create New Customer popup
      if (e.key == this.keyShortcuts.add_customer && (e.ctrlKey || e.metaKey)) {
        // present "Save Page" from getting triggered.
        e.preventDefault();
        this.$refs.billarea.createCustomermodal();
      }
      // open search Product popup
      if (
        e.key == this.keyShortcuts.customer_view &&
        (e.ctrlKey || e.metaKey)
      ) {
        // present "Save Page" from getting triggered.
        e.preventDefault();
        this.$refs.billarea.viewCustomer();
      }
      if (
        e.key == this.keyShortcuts.change_customer &&
        (e.ctrlKey || e.metaKey)
      ) {
        // present "Save Page" from getting triggered.
        e.preventDefault();
        this.focusCustomersearch();
      }
      // open Customer Bill
      if (e.key == this.keyShortcuts.bill_view && (e.ctrlKey || e.metaKey)) {
        // present "Save Page" from getting triggered.
        e.preventDefault();
        this.$refs.bottomButton.setTabNum(1);
      }
      // // open Customer Payment
      if (e.key == this.keyShortcuts.payment_view && (e.ctrlKey || e.metaKey)) {
        // present "Save Page" from getting triggered.
        e.preventDefault();
        this.$refs.bottomButton.setTabNum(0);
      }
      // open Brand Modal
      if (
        e.key == this.keyShortcuts.quotation_view &&
        (e.ctrlKey || e.metaKey)
      ) {
        // present "Save Page" from getting triggered.
        e.preventDefault();
        this.$refs.bottomButton.onOpenQutation();
      }
    };

    document.addEventListener("keydown", this._keyListener.bind(this));
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this._keyListener);
  },
  filters: {
    price: function (value) {
      return value.toFixed(2);
    },
  },

  methods: {
    emitdata() {
      this.$refs.callingfatchdata.fetchSales();
    },
    openProductSearch() {
      this.$refs.billarea.addNewPopup();
    },
    openBrandModal() {
      this.$refs.brandbutton.click();
    },
    openCustomersalesModal() {
      this.$refs.customersales.click();
    },
    openCategoryModal() {
      this.$refs.categorybutton.click();
    },
    openCustomerPopup() {
      this.$refs.billarea.createCustomermodal();
    },
    openCustomerDetails() {
      this.$refs.billarea.viewCustomer();
    },
    openCustomerBill() {
      this.$refs.billarea.openbillsection();
    },
    openCustomerPayment() {
      this.$refs.billarea.openPaymentsection();
    },
    focusCustomersearch() {
      this.$refs.billarea.focusCustomerlistSearch();
    },
  },
  computed: {
    ...mapState("salesReturn", ["sales_return_visible"]),
    ...mapState("bill", ["customer"]),
    ...mapState("auth", ["keyShortcuts"]),
    ...mapState("dashboard", ["sideArea"]),
    ...mapState("auth", ["help_tooltip_visible"]),
  },
};
</script>

<style>
.nuxt-container {
  /* min-height: calc(100vh - 95px); */
  /* min-height: calc(89vh); */
  /* background: linear-gradient(to right, #ece9e6, #ffffff); */
  font-family: "Roboto Slab", sans-serif;
  height: 94%;
}

.verticalButton-brand {
  padding: 0px 0px 0px 0px;
  width: 150px;
  height: 30px;
  background: #ff931e;
  border-radius: 5px 5px 0px 0px;
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  -webkit-transform: rotate(270deg);
  position: fixed;
  right: -60px;
  top: 150px;
}

.verticalButton-category {
  padding: 0px 0px 0px 0px;
  width: 150px;
  height: 30px;
  background: #007bff;
  background-color: rgb(0, 123, 255);
  border-radius: 5px 5px 0px 0px;
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  -webkit-transform: rotate(270deg);
  position: fixed;
  right: -60px;
  top: 301px;
}

.verticalButton-customer-history {
  padding: 0px 0px 0px 0px;
  width: 150px;
  height: 30px;
  background: #d31574;
  background-color: rgb(226, 33, 123);
  border-radius: 5px 5px 0px 0px;
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  -webkit-transform: rotate(270deg);
  position: fixed;
  right: -60px;
  top: 450px;
}

.container-whole {
  display: flex;
}

.container-left {
  width: 60%;
  margin: 0 10px;
}

.container-right {
  width: 40%;
}
</style>